import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { debounce } from "lodash";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getContent, getListServiceCode, getRequestTypesByServiceCOde as getRequestTypesByServiceCode, searchSendReceptData } from "services/SendReceptDataService";
import { findUnits, searchUnits } from "services/UnitService";
import { X_TOTAL_COUNT } from "utils/constants";
import { checkDateMonth, dateFormat1, dateFormat2, formatDate, range2 } from "utils/date";
import { handleError } from "utils/handleError";
import "./scss/SendReceptDataList.scss";
import SendReceptDataContent from "./SendReceptDataContent";
import { SendReceptDataContext } from "./SendReceptDataContext";
import { SendReceptDataHistory } from "./SendReceptDataHistory";
import { SendReceptDataMessage } from "./SendReceptDataMessage";

export const SendReceptDataList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["send-recept-data", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const sendRecptDataContext = useContext(SendReceptDataContext);
    const {
        sendReceptData,
        setSendReceptData,
        sendReceptDatas,
        setSendReceptDatas,
        sendReceptDataDialog,
        setSendReceptDataDialog,
        sendReceptDataHistoryDialog,
        setSendReceptDataHistoryDialog,
        sendReceptDataHistories,
        setSendReceptDataHistories,
        content,
        setContent,
        sendReceptDataContentDialog,
        setSendReceptDataContentDialog,
    } = sendRecptDataContext;

    const [loading, setLoading] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [units, setUnits] = useState([]);
    const [services, setServices] = useState([]);
    const [requestTypes, setRequestTypes] = useState([]);
    const [checkLoad, setCheckLoad] = useState(false);
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [selectUnit, setSelectUnit] = useState(null);

    const debounceSearchUnit = useCallback(
        debounce((valueText) => searchUnit(valueText), 100),
        []
    );

    const now = new Date();

    const beforeNow = new Date(new Date().setDate(new Date().getDate() - range2));
    const [formatDateVal, setFormatDateVal] = useState(dateFormat1);

    const maVungs = [
        { label: "Vùng trong", value: 1 },
        { label: "Vùng ngoài", value: 0 },
    ];

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            maVung: { value: maVungs[0].value, matchMode: "equals" },
            serviceCode: { value: null, matchMode: "equals" },
            idNumber: { value: "", matchMode: "equals" },
            requestType: { value: null, matchMode: "equals" },
            unitId: { value: null, matchMode: "equals" },
            fromDate: { value: beforeNow, matchMode: "equals" },
            toDate: { value: now, matchMode: "equals" },
        },
    });

    const statuses = [
        { label: "Chờ gửi/nhận", value: "0" },
        { label: "Gửi/nhận thành công", value: "1" },
        { label: "Chờ Gửi lại", value: "2" },
        { label: "Gửi lỗi", value: "3" },
    ];

    useEffect(() => {
        searchUnit();
    }, []);

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    useEffect(() => {
        if (lazyParams.filters.maVung?.value !== null && lazyParams.filters.maVung?.value !== undefined) {
            getListServiceCode(headers, lazyParams.filters.maVung.value)
                .then((res) => {
                    setServices(
                        res.data.map((e) => {
                            return { label: e[1], value: e[0] };
                        })
                    );
                })
                .catch((error) => handleError(toast, t, error));
        } else {
            setServices([]);
            setRequestTypes([]);
        }
    }, [lazyParams.filters.maVung]);

    useEffect(() => {
        if (lazyParams.filters.serviceCode.value) {
            getRequestTypesByServiceCode(headers, lazyParams.filters.serviceCode.value)
                .then((res) => {
                    setRequestTypes(
                        res.data.map((e) => {
                            return { label: e.requestTypeName, value: e.requestType };
                        })
                    );
                })
                .catch((error) => handleError(toast, t, error));
        } else {
            setRequestTypes([]);
        }
    }, [lazyParams.filters.serviceCode]);

    const searchUnit = (text = null, page = 0, rows = 20) => {
        if (text) {
            searchUnits(headers, text).then((res) => {
                setUnits(
                    res.data?.map((e) => {
                        return { label: e.name, value: e.id };
                    })
                );
            });
        } else {
            findUnits(headers, { rows, page })
                .then((res) => {
                    setUnits(
                        res.data?.map((e) => {
                            return { label: e.name, value: e.id };
                        })
                    );
                })
                .catch((error) => {
                    handleError(toast, t, error);
                });
        }
    };

    const loadLazyData = () => {
        setLoading(true);
        setSubmit(false);
        searchSendReceptData(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                });
                setSendReceptDatas(dataRes);
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => {
                setLoading(false);
            });
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const statusTemplateBody = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center">
                {/* error */}
                {/* {statuses[3].value === rowData?.status && (
                    <p
                        className="custom-error-status"
                        onClick={(e) => {
                            viewError(rowData.messErro);
                        }}
                    >
                        {statuses?.find((e) => e.value === rowData?.status)?.label}
                    </p>
                )} */}
                {/* not pk_id  */}
                {/* {statuses[3].value !== rowData?.status && !rowData?.isLog && <p>{statuses?.find((e) => e.value === rowData?.status)?.label}</p>} */}
                {/* pk_id  */}
                {/* {statuses[3].value !== rowData?.status && rowData?.isLog && (
                    <p
                        className="custom-link-status"
                        onClick={(e) => {
                            viewHistory(rowData?.logs);
                        }}
                    >
                        {statuses?.find((e) => e.value === rowData?.status)?.label}
                    </p>
                )} */}
                {statuses.find((e) => e.value == rowData?.status).label}
            </div>
        );
    };

    const serviceTemplate = (rowData) => {
        if (rowData.serviceCode) {
            return <div className="flex align-items-left justify-content-left">{services.find((e) => e.value === rowData?.serviceCode)?.label}</div>;
        }
        return null;
    };

    const requestTypeNameTemplate = (rowData) => {
        if (rowData.requestTypeName) {
            return <div className="flex align-items-left justify-content-left">{rowData.requestTypeName}</div>;
        }
        return null;
    };

    const viewError = (message) => {
        setSendReceptData(message);
        setSendReceptDataDialog(true);
    };

    const viewHistory = (logs) => {
        if (logs.length > 0) {
            logs.forEach((e, i) => {
                e.stt = i + 1;
            });
        }
        setSendReceptDataHistories(logs);
        setSendReceptDataHistoryDialog(true);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchItems = (event) => {
        if (!event.query) {
            debounceSearchUnit(null);
        } else {
            debounceSearchUnit(event.query);
        }
    };

    const searchOption = (
        <>
            <div className="grid">
                {/* mã vùng */}
                <div className="col-12 md:col-2">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "54px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0.75rem 0px 0px",
                            }}
                            htmlFor="maVung"
                        >
                            {t("send-receipt-data.maVung")} <span className="text-danger">*</span>
                        </label>
                        <Dropdown
                            className="col"
                            name="maVung"
                            id="maVung"
                            style={{ width: "100%", margin: "7px 0px 0px", padding: "0px" }}
                            value={lazyParams.filters.maVung.value}
                            options={maVungs}
                            onChange={(e) => {
                                setSubmit(false);
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        maVung: {
                                            ...lazyParams.filters.maVung,
                                            value: e.value,
                                        },
                                        requestType: {
                                            ...lazyParams.filters.requestType,
                                            value: null,
                                        },
                                        serviceCode: {
                                            ...lazyParams.filters.serviceCode,
                                            value: null,
                                        },
                                    },
                                });
                            }}
                            tooltip={maVungs.find((e) => e.value === lazyParams.filters.maVung.value)?.label}
                            tooltipOptions={{ position: "top" }}
                        ></Dropdown>
                    </div>
                </div>

                {/* tên dịch vụ */}
                <div className="col-12 md:col-4">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0.75rem 0px 0px",
                            }}
                            htmlFor="serviceCode"
                        >
                            {t("send-receipt-data.serviceCode")} <span className="text-danger">*</span>
                        </label>
                        <Dropdown
                            className="col"
                            style={{ width: "100%", margin: "5px 0px 0px 0px" }}
                            name="serviceCode"
                            id="serviceCode"
                            value={lazyParams.filters.serviceCode.value}
                            options={services}
                            required={true}
                            filter={true}
                            showClear={true}
                            onChange={(e) => {
                                setSubmit(false);
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        serviceCode: {
                                            ...lazyParams.filters.serviceCode,
                                            value: e.value,
                                        },
                                        requestType: {
                                            ...lazyParams.filters.requestType,
                                            value: null,
                                        },
                                    },
                                });
                                setRequestTypes([]);
                            }}
                            tooltip={services.find((e) => e.value === lazyParams.filters.serviceCode.value)?.label}
                            tooltipOptions={{ position: "top" }}
                        ></Dropdown>
                        {/* {!lazyParams.filters.serviceCode.value && submit && (
                            <small
                                className="text-danger"
                                style={{
                                    display: "grid",
                                    // width: "calc(100% - 100px)",
                                    "justify-content": "end",
                                }}
                            >
                                {t("send-receipt-data.serviceCodeRequired")}
                            </small>
                        )} */}
                    </div>
                </div>

                {/* loại yêu cầu */}
                <div className="col-12 md:col-4 ">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "120px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0.75rem 0px 0px",
                            }}
                            htmlFor="requestType"
                        >
                            {t("send-receipt-data.requestType")}
                        </label>
                        <Dropdown
                            className="col"
                            name="requestType"
                            id="requestType"
                            style={{ width: "100%", margin: "5px 0px 0px 0px" }}
                            value={lazyParams.filters.requestType.value}
                            options={requestTypes}
                            filter={true}
                            showClear={true}
                            onChange={(e) => {
                                setSubmit(false);
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        requestType: {
                                            ...lazyParams.filters.requestType,
                                            value: e.value,
                                        },
                                    },
                                });
                            }}
                            tooltip={requestTypes.find((e) => e.value === lazyParams.filters.requestType.value)?.label}
                            tooltipOptions={{ position: "top" }}
                        ></Dropdown>
                    </div>
                </div>

                {/* Số ĐDCN */}
                <div className="col-12 md:col-2">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="idNumber"
                        >
                            {t("send-receipt-data.idNumber")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="idNumber"
                                name="idNumber"
                                onChange={(e) => {
                                    setSubmit(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            idNumber: {
                                                ...lazyParams.filters.idNumber,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                {/* đơn vị */}
                <div className="col-12 md:col-4">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0.75rem 0px 0px",
                            }}
                            htmlFor="unitId"
                        >
                            {t("send-receipt-data.unitId")}
                        </label>
                        <AutoComplete
                            name="unitId"
                            className="col"
                            style={{ width: "100%", margin: "5px 0px 0px 0px" }}
                            id="unitId"
                            value={selectUnit}
                            suggestions={units}
                            completeMethod={searchItems}
                            field="label"
                            dropdown
                            onChange={(e) => {
                                setSubmit(false);
                                setCheckLoad(false);
                                setSelectUnit(e.value);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        unitId: {
                                            ...lazyParams.filters.unitId,
                                            value: e?.value?.value,
                                        },
                                    },
                                });
                            }}
                            dropdownAriaLabel="Chọn thường trú"
                            emptyMessage={"Không có dữ liệu"}
                            showEmptyMessage={true}
                            tooltip={units.find((e) => e.value === lazyParams?.filters.unitId?.value)?.label}
                            tooltipOptions={{ position: "top" }}
                            forceSelection
                        />
                    </div>
                </div>
                {/* thời gian gửi */}
                <div className="col-12 md:col-4">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "120px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="fromDate"
                        >
                            {t("send-receipt-data.fromDate")}
                        </label>
                        <div className="col">
                            <Calendar
                                style={{ width: "100%" }}
                                value={lazyParams.filters.fromDate.value}
                                onChange={(e) => {
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            fromDate: {
                                                ...lazyParams.filters.fromDate,
                                                value: e.value,
                                            },
                                        },
                                    });
                                }}
                                onBlur={() => {
                                    setFormatDateVal(dateFormat1);
                                }}
                                onFocus={() => {
                                    setFormatDateVal(dateFormat2);
                                }}
                                name="fromDate"
                                id="fromDate"
                                maxDate={lazyParams.filters.toDate.value}
                                dateFormat={formatDateVal}
                            ></Calendar>
                            {/* <InputText
                                className="col"
                                style={{
                                    width: "100%",
                                }}
                                type="date"
                                id="fromDate"
                                name="fromDate"
                                value={lazyParams.filters.fromDate.value}
                                max={lazyParams.filters.toDate.value}
                                onChange={(e) => {
                                    setSubmit(false);
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            fromDate: {
                                                ...lazyParams.filters.fromDate,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                    if (!lazyParams.filters.toDate.value && e.target.value) {
                                        let valueDate = new Date(e.target.value);
                                        valueDate = valueDate.setDate(valueDate.getDate() + 30);
                                        setMaxDate(new Date(valueDate).toISOString().slice(0, 10));
                                    } else if (!lazyParams.filters.toDate.value && !e.target.value) {
                                        setMaxDate(null);
                                        setMinDate(null);
                                    }
                                }}
                            ></InputText> */}
                        </div>
                    </div>
                </div>
                {/* Đến */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {t("send-receipt-data.toDate")}
                        </label>
                        <div className="col">
                            <Calendar
                                style={{ width: "100%" }}
                                value={lazyParams.filters.toDate.value}
                                onChange={(e) => {
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            toDate: {
                                                ...lazyParams.filters.toDate,
                                                value: e.value,
                                            },
                                        },
                                    });
                                }}
                                onBlur={() => {
                                    setFormatDateVal(dateFormat1);
                                }}
                                onFocus={() => {
                                    setFormatDateVal(dateFormat2);
                                }}
                                name="toDate"
                                id="toDate"
                                // maxDate={now}
                                minDate={lazyParams.filters.fromDate.value}
                                dateFormat={formatDateVal}
                            ></Calendar>
                        </div>
                        {/* <InputText
                            className="col"
                            style={{
                                width: "100%",
                            }}
                            type="date"
                            id="toDate"
                            name="toDate"
                            value={lazyParams.filters.toDate.value}
                            max={now}
                            min={lazyParams.filters.fromDate.value}
                            onChange={(e) => {
                                setCheckLoad(false);
                                setSubmit(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        toDate: {
                                            ...lazyParams.filters.toDate,
                                            value: e.target.value,
                                        },
                                    },
                                });
                                if (!lazyParams.filters.fromDate.value && !!e.target.value) {
                                    let valueDate = new Date(e.target.value);
                                    valueDate = valueDate.setDate(valueDate.getDate() - 30);
                                    setMinDate(new Date(valueDate).toISOString().slice(0, 10));
                                } else if (!lazyParams.filters.fromDate.value && !e.target.value) {
                                    setMaxDate(null);
                                    setMinDate(null);
                                }
                            }}
                        ></InputText> */}
                        {/* {!lazyParams.filters.toDate.value && submit && <small className="text-danger">{t("send-receipt-data.toDateRequired")}</small>} */}
                    </div>
                </div>
                <div className="col-12 md:col-1 text-right">
                    <div className="grid custom-form">
                        <div className="col-12">
                            <label
                                className="col-fixed text-center"
                                style={{
                                    width: "80px",
                                    justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                                htmlFor="idNumber"
                            >
                                {" "}
                            </label>
                        </div>
                        <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                            <Button
                                label={t("search", { ns: "common" })}
                                icon="pi pi-search"
                                onClick={(e) => {
                                    setSubmit(true);
                                    if (lazyParams.filters.serviceCode.value && lazyParams.filters.maVung.value !== null && lazyParams.filters.maVung.value !== undefined) {
                                        if (lazyParams.filters.idNumber.value) {
                                            setCheckLoad(true);
                                            setLazyParams({
                                                ...lazyParams,
                                                first: 0,
                                                page: 0,
                                            });
                                        } else {
                                            if (lazyParams.filters.fromDate.value && lazyParams.filters.toDate.value) {
                                                if (checkDateMonth(lazyParams.filters.fromDate.value, lazyParams.filters.toDate.value, range2)) {
                                                    setCheckLoad(true);
                                                    setLazyParams({
                                                        ...lazyParams,
                                                        first: 0,
                                                        page: 0,
                                                    });
                                                } else {
                                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("send-receipt-data.rangeFromToDate"), life: 3000 });
                                                }
                                            } else {
                                                toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("send-receipt-data.requiredfromandtodate"), life: 3000 });
                                            }
                                        }
                                    } else {
                                        toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("send-receipt-data.required"), life: 3000 });
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const createdDateTemplate = (rowData) => {
        if (rowData.createdDate) {
            const valueCreatedDate = rowData.createdDate.replaceAll("-", "/");
            return <div className="flex align-items-center justify-content-center actions">{valueCreatedDate}</div>;
        }
        return null;
    };

    const jobDateTemplate = (rowData) => {
        if (rowData.jobDate) {
            const valueJobDate = rowData.jobDate.replaceAll("-", "/");
            return <div className="flex align-items-center justify-content-center actions">{valueJobDate}</div>;
        }
        return null;
    };

    const unitNameTemplate = (rowData) => {
        return <div className="flex align-items-left justify-content-left actions">{rowData.unitName}</div>;
    };

    const openViewContent = (rowData) => {
        getContent(headers, rowData.id).then((res) => {
            if (res.data) {
                setContent(res.data);
                setSendReceptDataContentDialog(true);
            }
        });
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center actions" style={{ margin: "auto" }}>
                <Button icon="pi pi-eye" className="p-button-rounded p-button mr-2" tooltip={t("view", { ns: "common" })} onClick={() => openViewContent(rowData)} />
            </div>
        );
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("send-receipt-data.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("send-receipt-data.list")}>
                                <Toast ref={toast} />
                                <DataTable
                                    ref={dt}
                                    value={sendReceptDatas}
                                    dataKey="stt"
                                    className="datatable-responsive p-datatable-sm"
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    onSort={onSort}
                                    sortField={lazyParams.sortField}
                                    sortOrder={lazyParams.sortOrder}
                                    onFilter={onFilter}
                                    filters={lazyParams.filters}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorTemplate}
                                    emptyMessage="Không có dữ liệu"
                                    scrollable
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    <Column
                                        field="idNumber"
                                        header={t("send-receipt-data.idNumber")}
                                        style={{
                                            minWidth: "120px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                        }}
                                    />
                                    <Column
                                        field="serviceCode"
                                        header={t("send-receipt-data.serviceCode")}
                                        // body={serviceTemplate}
                                        style={{
                                            minWidth: "250px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                        }}
                                    />
                                    <Column
                                        field="requestTypeName"
                                        header={t("send-receipt-data.requestTypeName")}
                                        style={{
                                            minWidth: "200px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                        }}
                                        body={requestTypeNameTemplate}
                                    />
                                    <Column
                                        field="status"
                                        header={t("send-receipt-data.status")}
                                        body={statusTemplateBody}
                                        style={{
                                            minWidth: "120px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                        }}
                                    />
                                    <Column field="createdDate" header={t("send-receipt-data.startDate")} body={createdDateTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="jobDate" header={t("send-receipt-data.jobDate")} body={jobDateTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="lanChay" header={t("send-receipt-data.lanChay")} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="unitName" header={t("send-receipt-data.unitName")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} body={unitNameTemplate} />
                                    {/* <Column field="maVung" header={t("send-receipt-data.vung")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} /> */}
                                    <Column body={actionTemplate} style={{ minWidth: "80px" }} />
                                </DataTable>
                            </BlockDetail>
                            <SendReceptDataMessage />
                            <SendReceptDataHistory />
                            <SendReceptDataContent />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
